
<div :class="stylesheet.classes.presentation">
  <div :class="stylesheet.classes.presentationBody">
    <div v-if="template.icon.enable" class="card-icon" :class="stylesheet.classes.presentationIcon">
      <div v-if="useIconAsImage">
        <div
          class="img-fluid"
          :style="imgStylesGB"
        />
      </div>
      <div v-else :class="iconWrapperClasses">
        <icon-template
          :set="iconProperties.set"
          :selector="iconProperties.selector"
          :class="iconClasses"
        />
      </div>
    </div>
    <div :class="stylesheet.classes.presentationContent">
      <!-- eslint-disable vue/no-v-html -->
      <div v-if="template.headline.enable && !useExistingComponent" class="card-headline" v-html="titleHTML">

      </div>
      <div v-if="template.headline.enable && useExistingComponent" class="center-headline">
        <draft-froala  v-bind="draftHeadlineProps" :fb-node="draftHeadlineData"/>
      </div>
      <!-- eslint-disable vue/no-v-html -->
      <div v-if="template.subHeadline.enable && !useExistingComponent" class="center-text" v-html="descriptionHTML">
      </div>

      <div v-if="template.subHeadline.enable && useExistingComponent" class="center-text">
        <draft-froala  v-bind="draftTextProps" :fb-node="draftTextData"/>
      </div>

      <div  v-if="template.button.enable" :class="buttonWrapper">
        <c-button v-bind="buttonProps" :fb-node="buttonData"/>
      </div>
    </div>
  </div>
</div>
